// Utils
import {
  getFromLocalStorage,
  setInToLocalStorage,
  removeFromLocalStorage,
} from "../utils/webStorage";

class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(getFromLocalStorage("user"));
    return user?.refreshToken;
  }

  getLocalAccessToken() {
    const user = JSON.parse(getFromLocalStorage("user"));
    return user?.accessToken;
  }

  updateLocalAccessToken(token) {
    let user = JSON.parse(getFromLocalStorage("user"));
    user.accessToken = token;
    setInToLocalStorage("user", JSON.stringify(user));
  }

  getUser() {
    return JSON.parse(getFromLocalStorage("user"));
  }

  setUser(user) {
   
    setInToLocalStorage("user", JSON.stringify(user));
  }

  removeUser() {
    removeFromLocalStorage("user");
  }
}

export default new TokenService();
